/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

/**
 * Custom element wrapping the "Notify me" button rendered in place of the
 * Add-to-cart button when the current variant is sold out.
 *
 * On click, opens the global <klaviyo-bis-dialog> — primed directly if a
 * variant is already known, otherwise (`data-needs-size-selection`) on its
 * size-picker step, using the grid pre-rendered into this component's
 * `<template>`. No-op if BIS is disabled (no dialog on page).
 */
class NotifyMeComponent extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.notify-me-button');
    this.button?.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#handleClick);
  }

  #handleClick = () => {
    const dialog = /** @type {any} */ (document.getElementById('klaviyo-bis-dialog'));
    if (!dialog) return;

    if (this.dataset.needsSizeSelection === 'true') {
      if (!dialog.openForSizeSelection) return;
      const template = this.querySelector('template[data-notify-size-grid]');
      dialog.openForSizeSelection({
        productTitle: this.dataset.productTitle,
        sizeGrid: template instanceof HTMLTemplateElement ? template.content.cloneNode(true) : null,
      });
      return;
    }

    if (!dialog.openForVariant) return;
    dialog.openForVariant({
      variantId: this.dataset.variantId,
      productTitle: this.dataset.productTitle,
      variantTitle: this.dataset.variantTitle,
    });
  };
}

if (!customElements.get('notify-me-component')) {
  customElements.define('notify-me-component', NotifyMeComponent);
}
